import { Button, Tooltip } from "antd";
import { MdOutlineContrast } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { setThemeMode, THEME_MODES, useThemeMode } from "../../../style/theme-mode";

/**
 * Header eylemi: açık ↔ koyu tema. Seçim tarayıcıda saklanır (bkz. core/style/theme-mode.js).
 * Simge temaya göre değişmez (kontrast): nötr/kurumsal görünüm; geçilecek temayı tooltip söyler.
 */
export default function ThemeToggle() {
    const { t } = useTranslation();
    const mode = useThemeMode();
    const isDark = mode === THEME_MODES.DARK;
    // Düğme, tıklayınca GEÇİLECEK temayı söyler.
    const label = t(isDark ? 'Light theme' : 'Dark theme');

    return (
        <Tooltip title={label}>
            <Button
                type="text"
                className="header-action"
                aria-label={label}
                aria-pressed={isDark}
                onClick={() => setThemeMode(isDark ? THEME_MODES.LIGHT : THEME_MODES.DARK)}
                icon={<MdOutlineContrast size={18} />}
            />
        </Tooltip>
    );
}
